import { createSelector } from '@reduxjs/toolkit';
import { RootState } from 'store/store';

const selector = (state: RootState) => state.datasourceColumns;

const DatasourceColumnsData = createSelector([selector], (state) => state);

export default {
  DatasourceColumnsData
};
